import { StudentProgramRegistrationModel } from "app/models/scheduling/StudentProgramRegistrationModel";

/**
 * Returns true if a registration's payment details should not be editable.
 *
 * Locked when:
 * 1. Online payment that is already paid or confirmed
 * 2. Online Charge Now (card_on_file + immediate) that is pending (charge in-flight) — unless failed
 */
export function isRegistrationPaymentLocked(registration: StudentProgramRegistrationModel): boolean {
  if (registration.paymentMethod !== 'online') {
    return false;
  }

  const status = registration.paymentStatus;

  // Rule 1: Paid or confirmed online payments are locked
  if (status === 'paid' || status === 'payment_confirmed') {
    return true;
  }

  // Rule 2: Pending Charge Now (card_on_file + immediate) is locked, unless failed
  if (
    registration.onlinePaymentType === 'card_on_file' &&
    registration.chargeTiming === 'immediate' &&
    (status === 'pending' || status === 'pending_payment')
  ) {
    return true;
  }

  return false;
}
